(function () {
  // Evita doppie inizializzazioni del file
  if (window.__OBS_WISHLIST_INIT__) return;
  window.__OBS_WISHLIST_INIT__ = true;

  // URL wishlist definito in modo "safe" (niente const globale)
  window.WISHLIST_URL = window.WISHLIST_URL || ((window.MO && window.MO.wishlistUrl) || '/pages/myobservewishlist');

  // Fallback localforage una sola volta
  if (typeof window.localforage === 'undefined') {
    window.localforage = {
      getItem: () => Promise.resolve(null),
      setItem: (_k, v) => Promise.resolve(v),
      removeItem: () => Promise.resolve(),
      clear: () => Promise.resolve(),
      keys: () => Promise.resolve([]),
      ready: () => Promise.resolve()
    };
    console.warn('localforage non caricato: uso fallback no-op');
  }

  // Se per qualche motivo non c'è comunque, esci
  if (!window.localforage) {
    console.warn('localforage non disponibile');
    return;
  }

  // -- Utils ---------------------------------------------------------
  function safeParseProduct(heartEl) {
    try {
      const host = heartEl.closest('.heart-icon') || heartEl;
      let raw = host.getAttribute('data-product');
      if (!raw || raw === 'null' || raw === 'undefined') return null;

      // Decodifica entità HTML
      const txt = document.createElement('textarea');
      txt.innerHTML = raw;
      raw = txt.value;

      const obj = JSON.parse(raw);
      if (!obj || obj.id == null) return null;
      obj.id = String(obj.id); // normalizza l'id a stringa
      return obj;
    } catch (e) {
      console.warn('safeParseProduct: JSON non valido per heart-icon', e, heartEl);
      return null;
    }
  }

  function cleanList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .filter(Boolean)
      .filter((it) => it && it.id != null)
      .map((it) => ({ ...it, id: String(it.id) }));
  }

  function getWishlist() {
    return window.localforage.getItem('wishlist').then(cleanList);
  }

  function setWishlist(w) {
    return window.localforage.setItem('wishlist', cleanList(w));
  }

  // -- Click su cuore ------------------------------------------------
  document.addEventListener(
    'click',
    function (event) {
      const heart = event.target.closest('.heart-icon');
      if (!heart) return;

      event.preventDefault();
      event.stopPropagation();

      const product = safeParseProduct(heart);
      if (!product) {
        console.warn('heart senza data-product valido', heart);
        const heartPath = heart.querySelector('.heart-path');
        if (heartPath) heartPath.style.fill = 'none';
        return;
      }

      const heartPath = heart.querySelector('.heart-path');

      getWishlist()
        .then(function (wishlist) {
          const idx = wishlist.findIndex((it) => it.id === product.id);
          if (idx > -1) {
            // rimozione
            wishlist.splice(idx, 1);
            if (heartPath) heartPath.style.fill = 'none';
          } else {
            // ==========================================
            // LIMITE MASSIMO PRODOTTI
            // ==========================================
            if (wishlist.length >= 40) {
              alert("Hai raggiunto il limite massimo di 40 prodotti nella Wishlist!");
              return wishlist; // Blocca l'aggiunta e restituisce la lista intatta
            }

            // aggiunta se il limite non è superato
            wishlist.push(product);
            if (heartPath) heartPath.style.fill = '#c99eeb';

            // TOAST opzionale
            if (window.WishToast && typeof WishToast.show === 'function') {
              WishToast.show(product);
            }
          }
          return setWishlist(wishlist);
        })
        .then(() => {
          loadWishlist();
          updateWishlistCounter(); // AGGIORNA IL BADGE SUBITO DOPO IL CLICK
        })
        .catch(function (err) {
          console.error('toggleWishlist errore:', err);
        });
    },
    { passive: false }
  );

  // -- Sync stato cuori ----------------------------------------------
  function loadWishlist() {
    getWishlist()
      .then(function (wishlist) {
        const hearts = document.querySelectorAll('.heart-icon');
        hearts.forEach(function (heart) {
          const product = safeParseProduct(heart);
          const heartPath = heart.querySelector('.heart-path');
          if (!heartPath) return;

          if (!product) {
            heartPath.style.fill = 'none';
            return;
          }

          const isSaved = wishlist.some((it) => it.id === product.id);
          heartPath.style.fill = isSaved ? '#c99eeb' : 'none';
        });
      })
      .catch(function (err) {
        console.error('loadWishlist errore:', err);
      });
  }

  document.addEventListener('DOMContentLoaded', loadWishlist);
  window.addEventListener('load', function () {
    setTimeout(loadWishlist, 800);
  });

  // Se usi eventi custom quando arrivano nuovi risultati
  document.addEventListener('mo:search:results-mounted', () => loadWishlist());
  document.addEventListener('obs:search:results', () => loadWishlist());

  // Aggiorna quando compaiono nuovi cuori nel DOM (AJAX, ecc.)
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver((mutations) => {
      let updated = false;
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.matches?.('.heart-icon') || node.querySelector?.('.heart-icon'))
          ) {
            updated = true;
          }
        });
      });
      if (updated) loadWishlist();
    });
    // observer.observe(document.body, { childList: true, subtree: true });
  });

  // --- NUOVA FUNZIONE: Aggiorna il contatore nell'header ---
  function updateWishlistCounter() {
    getWishlist().then(function(wishlist) {
      const count = wishlist.length;
      
      // MODIFICA: Cerca i badge usando la nuova classe comune invece dell'ID
      const badges = document.querySelectorAll('.js-wishlist-count');
      
      badges.forEach(badge => {
        if (count > 0) {
          badge.textContent = count;
          badge.classList.remove('hidden');
        } else {
          badge.classList.add('hidden');
        }
      });
    });
  }

  // Aggiorna il contatore al caricamento e dopo ogni modifica
  document.addEventListener('DOMContentLoaded', updateWishlistCounter);
  window.addEventListener('load', updateWishlistCounter);
  
  // Intercetta l'evento custom lanciato quando eliminiamo la card dalla pagina wishlist
  document.addEventListener('wishlist:updated', updateWishlistCounter);

})();